export enum AssetTypeEnum {
    
    MOVABLE = 'MOVABLE',
    NONMOVABLE = 'NON-MOVABLE',
    SOFTASSET = 'SOFTASSET',
}